"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { installFeedbackScrollUnlock } from "@/lib/feedback-scroll-unlock";

/**
 * 모달이 열려 있어도 피드백 위젯 패널 안에서는 휠/터치 스크롤이 동작하게 한다.
 * 자세한 배경은 `@/lib/feedback-scroll-unlock` 주석 참조.
 */
export function FeedbackScrollUnlock() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  return null;
}
function _temp() {
  return installFeedbackScrollUnlock();
}